export const initialUrl = '/inicio';
// url will open
